export const DEFAULT_TEXT_LENGTH = 40;
